export default "__VITE_ASSET__DT3GQJ5t__"